import { css } from '@emotion/react'
import styled from '@emotion/styled'
export const StyleInputWrapper = styled.div<any>`
  position: relative;
  flex: 1;
  width: 100%;
  ${(props: any) =>
    props.hasAddButton &&
    css`
      width: 50%;
      display: flex;
      align-items: stretch;
      @media (max-width: 768px) {
        width: 90%;
      }
    `};
`
export const StyleInput = styled.input<any>`
  width: 100%;
  border-radius: 6px;
  height: 40px;
  text-indent: ${(props) =>
    props?.hasIcon && props?.side == 'left' ? '35px' : '10px'};
  padding: 0px 0px;
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : !!props?.isFocus
          ? props.theme.colors.primary
          : props.theme.colors.borderColor};
  outline: none;
  font-size: 14px;
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    letter-spacing: 0.25px;
    line-height: 16px;
  }
  background-color: ${(props) =>
    props.theme.colors[props?.disabled ? 'white' : 'white']};
  cursor: ${(props) => (props?.disabled ? 'not-allowed' : 'pointer')};

  ${(props) => props.hasIcon && props?.side == 'right' && `padding-left: 35px;`}
  ${(props) => props.styleInput}


  &::-webkit-calendar-picker-indicator {
    filter: invert(0.5);
    cursor: pointer;
  }

  &[type='date'],
  &[type='time'] {
    appearance: none;
    -webkit-appearance: none;
    background-color: white;
    padding-right: 12px;
    color: #333;
  }
`

export const StyleIconWrapper = styled.div<any>`
  position: absolute;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    display: block;
  }
  ${(props) => {
    if (props.side == 'right') {
      return `right: 0px;`
    } else {
      return `left: 0px;`
    }
  }}
`
